<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Reglas
      b-col(cols="auto")
        b-button.mr-2(variant="primary", @click="createRule", :disabled="loading || busy") Crear regla
    rule-block(v-for="rule in rules", :key="rule.rule_id", :rule="rule")

</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import RuleBlock from '../../components/RuleBlock.vue'
const ruleController = createNamespacedHelpers('rule')

export default {
  data () {
    return {
      loading: false,
      busy: false,
    }
  },
  computed: {
    ...ruleController.mapState({
      rules: state => state.rules
    }),
  },
  methods: {
    ...mapActions(['rule/all', 'rule/create']),
    getRules () {
      let self = this
      this.loading = true

      this['rule/all']({
        account_id: self.$route.params.account_id,
        ...self.paginationParamsObject,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    createRule () {
      let self = this

      this['rule/create']({
        name: 'Nueva regla',
        description: '',
        enabled: true,
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Regla creada')
          }
        }
      })
    },
  },
  mounted () {
    this.getRules()
  },
  components: {RuleBlock}
}
</script>

<style lang="scss" scoped>
</style>
